export default "__VITE_PUBLIC_ASSET__7373183d__"